export enum PaginationNames {
  Cards = 'Cards',
  Packs = 'Packs',
}
